var isObject = require('../internals/is-object');

var document = require('../internals/global').document; // typeof document.createElement is 'object' in old IE


var exist = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return exist ? document.createElement(it) : {};
};